exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".actions-column-header[data-v-ae6f41a0]{width:35px}.datatable-padding[data-v-ae6f41a0]{padding:0}.datatable[data-v-ae6f41a0]{width:100%;margin:0 auto;clear:both;border-collapse:separate;border-spacing:0;box-sizing:content-box}.datatable thead>tr>th[data-v-ae6f41a0]{padding:15px 18px;background:#eee}.table-responsive[data-v-ae6f41a0]{overflow-x:visible}.datatable-empty-row>td[data-v-ae6f41a0]{text-align:center;padding:15px;font-style:italic;background-color:#f9f9f9}", ""]);

// exports
